import { getField } from "@joandvgv/vuex-map-fields";
export const CURRENT_USER_DETAILS = "CURRENT_USER_DETAILS";
export const CURRENT_USER_USERNAME = "CURRENT_USER_USERNAME";
export const ACCOUNT_SUBDOMAIN = "ACCOUNT_SUBDOMAIN";
export const GET_AGENT_DETAILS_BY_SUBDOMAIN = "GET_AGENT_DETAILS_BY_SUBDOMAIN";
export const AGENT_ACCOUNT_DETAILS = "AGENT_ACCOUNT_DETAILS";
export const CURRENT_ACCOUNT_DETAILS = "CURRENT_ACCOUNT_DETAILS";
export const CURRENT_BROKERAGE_DETAILS = "CURRENT_BROKERAGE_DETAILS";
export const EMAIL_VERIFICATION = "EMAIL_VERIFICATION";
export const EMAIL_VERIFIED = "EMAIL_VERIFIED";
export const EMAIL_VERIFIED_ALREADY_SENT = "EMAIL_VERIFIED_ALREADY_SENT";
export const IS_NEW_ACCOUNT_CREATED_USING_EMBEDDED_LINK = "IS_NEW_ACCOUNT_CREATED_USING_EMBEDDED_LINK";
export const GET_ACCOUNT_AGENTS = "GET_ACCOUNT_AGENTS";
export const LENDER_DOCUMENTS_FULLY_LOADED = "LENDER_DOCUMENTS_FULLY_LOADED";
export const LENDER_DOCUMENTS_FULLY_COUNT = "LENDER_DOCUMENTS_FULLY_COUNT";
const getters = {
  getField,
  [CURRENT_USER_DETAILS]: state => {
    return state.userDetails;
  },
  [CURRENT_USER_USERNAME]: (state, getters) => {
    const {
      username
    } = getters.CURRENT_USER_DETAILS;
    return username;
  },
  [ACCOUNT_SUBDOMAIN]: state => {
    const {
      accountDetails: {
        accountSubdomain: subdomain
      }
    } = state;
    return subdomain;
  },
  [GET_AGENT_DETAILS_BY_SUBDOMAIN]: state => {
    return state.brokerageId;
  },
  [AGENT_ACCOUNT_DETAILS]: state => state.public.agentAccountDetails || {},
  [CURRENT_ACCOUNT_DETAILS]: state => {
    return state.accountDetails;
  },
  [CURRENT_BROKERAGE_DETAILS]: state => {
    return state.brokerageDetails;
  },
  [EMAIL_VERIFICATION]: state => {
    return state.verification;
  },
  [EMAIL_VERIFIED]: state => {
    return state.accountDetails.emailVerified;
  },
  [EMAIL_VERIFIED_ALREADY_SENT]: state => {
    return state.verificationEmailSent;
  },
  [IS_NEW_ACCOUNT_CREATED_USING_EMBEDDED_LINK]: state => {
    return state.newAccountCreatedEmbeddedLink;
  },
  [GET_ACCOUNT_AGENTS]: state => {
    return state.agents;
  },
  [LENDER_DOCUMENTS_FULLY_LOADED]: state => {
    var _state$lenderData$doc;
    return ((_state$lenderData$doc = state.lenderData.documents) == null ? void 0 : _state$lenderData$doc.length) && state.lenderData.documentsCount === state.lenderData.documents.length;
  },
  [LENDER_DOCUMENTS_FULLY_COUNT]: state => {
    var _state$lenderData;
    return Number(((_state$lenderData = state.lenderData) == null ? void 0 : _state$lenderData.documentsCount) || "0");
  }
};
export default getters;